import React, { useState } from "react";

import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Button,
    MenuItem,
    Divider,
    IconButton,
    Tooltip,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";
import ImageIcon from "@mui/icons-material/Image";

import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";

import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";


const CrearNoticia = ({
    onVolver,
    onGuardar,
}) => {

   const [form, setForm] = useState({
    tipo: "",
    fecha: "",
    titulo: "",
    descripcion: "",
    img1: null,
    img2: null,
});


    /*
    |--------------------------------------------------------------------------
    | EDITOR
    |--------------------------------------------------------------------------
    */

    const editor = useEditor({

        extensions: [
            StarterKit,
            Underline,
        ],

        content: "",

        editorProps: {
            attributes: {
                class:
                    "noticia-editor-content",
            },
        },

    });


    /*
    |--------------------------------------------------------------------------
    | CAMBIAR CAMPOS
    |--------------------------------------------------------------------------
    */

    const handleChange = (e) => {

        const {
            name,
            value,
        } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    /*
    |--------------------------------------------------------------------------
    | CAMBIAR IMAGEN
    |--------------------------------------------------------------------------
    */

    const handleImageChange = (e) => {

        const {
            name,
            files,
        } = e.target;

        if (!files || !files[0]) {
            return;
        }

        setForm((prev) => ({
            ...prev,
            [name]: files[0],
        }));
    };


    /*
    |--------------------------------------------------------------------------
    | GUARDAR
    |--------------------------------------------------------------------------
    */

  const handleSubmit = (e) => {
    e.preventDefault();

    // VALIDACIONES

    if (!form.tipo) {
        alert("Selecciona el tipo de publicación.");
        return;
    }

    if (!form.fecha) {
        alert("Selecciona la fecha.");
        return;
    }

    if (!form.titulo.trim()) {
        alert("Ingresa el título.");
        return;
    }

    if (!form.descripcion.trim()) {
        alert("Ingresa la descripción o premisa de la noticia.");
        return;
    }

    if (!form.img1) {
        alert("Selecciona la imagen de portada.");
        return;
    }

    if (!form.img2) {
        alert("Selecciona la imagen interior.");
        return;
    }

    if (!editor || editor.isEmpty) {
        alert("Ingresa el contenido de la noticia.");
        return;
    }

    // FORM DATA

    const formData = new FormData();

    formData.append("tipo", form.tipo);
    formData.append("fecha", form.fecha);
    formData.append("titulo", form.titulo.trim());
    formData.append("descripcion", form.descripcion.trim());

    formData.append("img1", form.img1);
    formData.append("img2", form.img2);

    formData.append(
        "contenido",
        editor.getHTML()
    );

    // ENVIAR AL PADRE

    onGuardar(formData);
};
    if (!editor) {
        return null;
    }


    return (

        <Box
            sx={{
                maxWidth: "1100px",
                mx: "auto",
                pb: 5,
            }}
        >

            {/* VOLVER */}

            <Button
                startIcon={
                    <ArrowBackIcon />
                }
                onClick={onVolver}
                sx={{
                    mb: 3,
                    textTransform:
                        "none",
                    color: "#22324A",
                }}
            >
                Volver a noticias
            </Button>


            {/* CARD PRINCIPAL */}

            <Card
                sx={{
                    borderRadius: 3,
                    border:
                        "1px solid #E7EAF0",
                    boxShadow: "none",
                }}
            >

                <CardContent
                    sx={{
                        p: 4,
                    }}
                >

                    {/* TITULO */}

                    <Typography
                        sx={{
                            fontSize:
                                "1.7rem",
                            fontWeight: 700,
                            color: "#22324A",
                        }}
                    >
                        Crear noticia
                    </Typography>


                    <Typography
                        sx={{
                            color: "#7A828D",
                            mb: 4,
                        }}
                    >
                        Crea una nueva publicación
                        para la comunidad educativa.
                    </Typography>


                    <Box
                        component="form"
                        onSubmit={
                            handleSubmit
                        }
                    >


                        {/* TIPO + FECHA */}

                        <Box
                            sx={{
                                display:
                                    "grid",

                                gridTemplateColumns:
                                    {
                                        xs: "1fr",
                                        md: "1fr 1fr",
                                    },

                                gap: 3,

                                mb: 3,
                            }}
                        >

                            {/* TIPO */}

                            <TextField
                                select
                                label="Tipo de publicación"
                                name="tipo"
                                value={
                                    form.tipo
                                }
                                onChange={
                                    handleChange
                                }
                                required
                                fullWidth
                            >

                                <MenuItem value="comunicado">
                                    Comunicado
                                </MenuItem>

                                <MenuItem value="talleres">
                                    Talleres
                                </MenuItem>

                                <MenuItem value="eventos">
                                    Eventos
                                </MenuItem>

                                <MenuItem value="academico">
                                    Académico
                                </MenuItem>

                                <MenuItem value="matriculas">
                                    Matrículas
                                </MenuItem>

                                <MenuItem value="deporte">
                                    Deporte
                                </MenuItem>

                            </TextField>


                            {/* FECHA */}

                            <TextField
                                label="Fecha"
                                name="fecha"
                                type="date"
                                value={
                                    form.fecha
                                }
                                onChange={
                                    handleChange
                                }
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required
                                fullWidth
                            />

                        </Box>


                        {/* TITULO */}

                        <TextField
                            label="Título de la noticia"
                            name="titulo"
                            value={
                                form.titulo
                            }
                            onChange={
                                handleChange
                            }
                            required
                            fullWidth
                            sx={{
                                mb: 3,
                            }}
                        />


                        {/* DESCRIPCION */}

                        <TextField
                            label="Descripción / Premisa"
                            name="descripcion"
                            value={
                                form.descripcion
                            }
                            onChange={
                                handleChange
                            }
                            placeholder="Escribe una breve descripción que aparecerá fuera de la noticia..."
                            multiline
                            rows={3}
                            required
                            fullWidth
                            sx={{
                                mb: 3,
                            }}
                        />


                        {/* IMAGENES */}

                        <Typography
                            sx={{
                                fontWeight: 600,
                                color: "#22324A",
                                mb: 2,
                            }}
                        >
                            Imágenes de la noticia
                        </Typography>


                        <Box
                            sx={{
                                display:
                                    "grid",

                                gridTemplateColumns:
                                    {
                                        xs: "1fr",
                                        md: "1fr 1fr",
                                    },

                                gap: 3,

                                mb: 4,
                            }}
                        >

                            {/* IMAGEN PORTADA */}

                            <Card
                                variant="outlined"
                                sx={{
                                    p: 2,
                                    borderRadius: 2,
                                }}
                            >

                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        mb: 1,
                                    }}
                                >
                                    Imagen de portada
                                </Typography>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        color:
                                            "#7A828D",
                                        mb: 2,
                                    }}
                                >
                                    Esta imagen aparecerá
                                    como portada de la noticia.
                                </Typography>


                                <Button
                                    component="label"
                                    variant="outlined"
                                    startIcon={
                                        <ImageIcon />
                                    }
                                    fullWidth
                                    sx={{
                                        textTransform:
                                            "none",
                                        borderRadius: 2,
                                    }}
                                >

                                    Seleccionar imagen

                                    <input
                                        hidden
                                        type="file"
                                        name="img1"
                                        accept="image/*"
                                        onChange={
                                            handleImageChange
                                        }
                                    />

                                </Button>


                                {form.img1 && (

                                    <Typography
                                        variant="body2"
                                        sx={{
                                            mt: 1,
                                            color:
                                                "#22324A",
                                        }}
                                    >
                                        {form.img1.name}
                                    </Typography>

                                )}

                            </Card>


                            {/* IMAGEN INTERIOR */}

                            <Card
                                variant="outlined"
                                sx={{
                                    p: 2,
                                    borderRadius: 2,
                                }}
                            >

                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        mb: 1,
                                    }}
                                >
                                    Imagen interior
                                </Typography>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        color:
                                            "#7A828D",
                                        mb: 2,
                                    }}
                                >
                                    Esta imagen aparecerá
                                    dentro de la noticia.
                                </Typography>


                                <Button
                                    component="label"
                                    variant="outlined"
                                    startIcon={
                                        <ImageIcon />
                                    }
                                    fullWidth
                                    sx={{
                                        textTransform:
                                            "none",
                                        borderRadius: 2,
                                    }}
                                >

                                    Seleccionar imagen

                                    <input
                                        hidden
                                        type="file"
                                        name="img2"
                                        accept="image/*"
                                        onChange={
                                            handleImageChange
                                        }
                                    />

                                </Button>


                                {form.img2 && (

                                    <Typography
                                        variant="body2"
                                        sx={{
                                            mt: 1,
                                            color:
                                                "#22324A",
                                        }}
                                    >
                                        {form.img2.name}
                                    </Typography>

                                )}

                            </Card>

                        </Box>


                        {/* CONTENIDO */}

                        <Typography
                            sx={{
                                fontWeight: 600,
                                color: "#22324A",
                                mb: 1,
                            }}
                        >
                            Contenido de la noticia
                        </Typography>


                        <Card
                            variant="outlined"
                            sx={{
                                borderRadius: 2,
                                overflow:
                                    "hidden",
                            }}
                        >

                            {/* TOOLBAR */}

                            <Box
                                sx={{
                                    display:
                                        "flex",
                                    alignItems:
                                        "center",
                                    flexWrap:
                                        "wrap",
                                    gap: 0.5,
                                    p: 1,
                                    backgroundColor:
                                        "#F7F8FA",
                                    borderBottom:
                                        "1px solid #E0E3E8",
                                }}
                            >

                                {/* BOLD */}

                                <Tooltip title="Negrita">

                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            editor
                                                .chain()
                                                .focus()
                                                .toggleBold()
                                                .run()
                                        }
                                    >
                                        <FormatBoldIcon />
                                    </IconButton>

                                </Tooltip>


                                {/* ITALIC */}

                                <Tooltip title="Cursiva">

                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            editor
                                                .chain()
                                                .focus()
                                                .toggleItalic()
                                                .run()
                                        }
                                    >
                                        <FormatItalicIcon />
                                    </IconButton>

                                </Tooltip>


                                {/* UNDERLINE */}

                                <Tooltip title="Subrayado">

                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            editor
                                                .chain()
                                                .focus()
                                                .toggleUnderline()
                                                .run()
                                        }
                                    >
                                        <FormatUnderlinedIcon />
                                    </IconButton>

                                </Tooltip>


                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{
                                        mx: 0.5,
                                    }}
                                />


                                {/* LISTA */}

                                <Tooltip title="Lista">

                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            editor
                                                .chain()
                                                .focus()
                                                .toggleBulletList()
                                                .run()
                                        }
                                    >
                                        <FormatListBulletedIcon />
                                    </IconButton>

                                </Tooltip>


                                {/* LISTA NUMERADA */}

                                <Tooltip title="Lista numerada">

                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            editor
                                                .chain()
                                                .focus()
                                                .toggleOrderedList()
                                                .run()
                                        }
                                    >
                                        <FormatListNumberedIcon />
                                    </IconButton>

                                </Tooltip>


                                {/* CITA */}

                                <Tooltip title="Cita">

                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            editor
                                                .chain()
                                                .focus()
                                                .toggleBlockquote()
                                                .run()
                                        }
                                    >
                                        <FormatQuoteIcon />
                                    </IconButton>

                                </Tooltip>


                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{
                                        mx: 0.5,
                                    }}
                                />


                                {/* UNDO */}

                                <Tooltip title="Deshacer">

                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            editor
                                                .chain()
                                                .focus()
                                                .undo()
                                                .run()
                                        }
                                    >
                                        <UndoIcon />
                                    </IconButton>

                                </Tooltip>


                                {/* REDO */}

                                <Tooltip title="Rehacer">

                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            editor
                                                .chain()
                                                .focus()
                                                .redo()
                                                .run()
                                        }
                                    >
                                        <RedoIcon />
                                    </IconButton>

                                </Tooltip>

                            </Box>


                            {/* EDITOR */}

                            <Box
                                sx={{
                                    minHeight:
                                        "350px",
                                    p: 2,

                                    "& .noticia-editor-content":
                                        {
                                            minHeight:
                                                "320px",
                                            outline:
                                                "none",
                                            fontFamily:
                                                "Poppins, sans-serif",
                                            fontSize:
                                                "0.95rem",
                                            lineHeight:
                                                1.8,
                                            color:
                                                "#333",
                                        },

                                    "& .noticia-editor-content p":
                                        {
                                            margin:
                                                "0 0 12px 0",
                                        },

                                    "& .noticia-editor-content h1":
                                        {
                                            fontSize:
                                                "2rem",
                                        },

                                    "& .noticia-editor-content h2":
                                        {
                                            fontSize:
                                                "1.5rem",
                                        },

                                    "& .noticia-editor-content ul":
                                        {
                                            paddingLeft:
                                                "25px",
                                        },

                                    "& .noticia-editor-content ol":
                                        {
                                            paddingLeft:
                                                "25px",
                                        },

                                    "& .noticia-editor-content blockquote":
                                        {
                                            borderLeft:
                                                "4px solid #22324A",
                                            paddingLeft:
                                                "15px",
                                            color:
                                                "#666",
                                        },
                                }}
                            >

                                <EditorContent
                                    editor={editor}
                                />

                            </Box>

                        </Card>


                        {/* BOTONES */}

                        <Box
                            sx={{
                                display:
                                    "flex",
                                justifyContent:
                                    "flex-end",
                                gap: 2,
                                mt: 4,
                            }}
                        >

                            <Button
                                onClick={
                                    onVolver
                                }
                                sx={{
                                    textTransform:
                                        "none",
                                    color: "#666",
                                }}
                            >
                                Cancelar
                            </Button>


                            <Button
                                type="submit"
                                variant="contained"
                                startIcon={
                                    <SaveIcon />
                                }
                                sx={{
                                    backgroundColor:
                                        "#22324A",
                                    borderRadius: 2,
                                    textTransform:
                                        "none",
                                    fontWeight: 600,

                                    "&:hover": {
                                        backgroundColor:
                                            "#182536",
                                    },
                                }}
                            >
                                Publicar noticia
                            </Button>

                        </Box>

                    </Box>

                </CardContent>

            </Card>

        </Box>
    );
};


export default CrearNoticia;